/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Overlay_Redacted_LabelInputs */

const bn_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংশোধন করা হয়েছে`)
};

const de_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZENSIERT`)
};

const el_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΑΝΑΔΙΑΓΡΑΦΕΙ`)
};

const en_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDACTED`)
};

const es_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CENSURADO`)
};

const fr_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASQUÉ`)
};

const hi_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संशोधित`)
};

const hu_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SZERKESZTETT`)
};

const id_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIHAPUS`)
};

const it_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDATTO`)
};

const ja_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集済み`)
};

const ko_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`편집됨`)
};

const nl_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEREGISTREERD`)
};

const pl_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZMIENIONO`)
};

const pt_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REMODELADO`)
};

const ru_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`УДАЛЕНО`)
};

const sv_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAKTERAD`)
};

const tr_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DÜZELTİLDİ`)
};

const uk_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВИДАЛЕНО`)
};

const vi_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐÃ XÓA`)
};

const zh_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已编辑`)
};

const zh_hant_cipher_overlay_redacted_label = /** @type {(inputs: Cipher_Overlay_Redacted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已編輯`)
};

/**
* | output |
* | --- |
* | "REDACTED" |
*
* @param {Cipher_Overlay_Redacted_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_overlay_redacted_label = /** @type {((inputs?: Cipher_Overlay_Redacted_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Overlay_Redacted_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_overlay_redacted_label(inputs)
	if (locale === "de") return de_cipher_overlay_redacted_label(inputs)
	if (locale === "el") return el_cipher_overlay_redacted_label(inputs)
	if (locale === "en") return en_cipher_overlay_redacted_label(inputs)
	if (locale === "es") return es_cipher_overlay_redacted_label(inputs)
	if (locale === "fr") return fr_cipher_overlay_redacted_label(inputs)
	if (locale === "hi") return hi_cipher_overlay_redacted_label(inputs)
	if (locale === "hu") return hu_cipher_overlay_redacted_label(inputs)
	if (locale === "id") return id_cipher_overlay_redacted_label(inputs)
	if (locale === "it") return it_cipher_overlay_redacted_label(inputs)
	if (locale === "ja") return ja_cipher_overlay_redacted_label(inputs)
	if (locale === "ko") return ko_cipher_overlay_redacted_label(inputs)
	if (locale === "nl") return nl_cipher_overlay_redacted_label(inputs)
	if (locale === "pl") return pl_cipher_overlay_redacted_label(inputs)
	if (locale === "pt") return pt_cipher_overlay_redacted_label(inputs)
	if (locale === "ru") return ru_cipher_overlay_redacted_label(inputs)
	if (locale === "sv") return sv_cipher_overlay_redacted_label(inputs)
	if (locale === "tr") return tr_cipher_overlay_redacted_label(inputs)
	if (locale === "uk") return uk_cipher_overlay_redacted_label(inputs)
	if (locale === "vi") return vi_cipher_overlay_redacted_label(inputs)
	if (locale === "zh") return zh_cipher_overlay_redacted_label(inputs)
	return zh_hant_cipher_overlay_redacted_label(inputs)
});